export class ValidationError {
  constructor(errors, headers) {
    this.code = 400
    this.errors = errors
    this.headers = headers
  }
}

export class TechnicalError {
  constructor(error) {
    this.error = error
    this.code = 500
  }
}

export class UnauthorizedError {
  constructor() {
    this.code = 401
  }
}

export class NotFoundError {
  constructor(response, headers) {
    this.code = 404
    this.response = response
    this.headers = headers
  }
}

export class NotJsonError {
  constructor(response) {
    this.code = 400
    this.response = response
  }
}

export class ForbiddenError {
  constructor() {
    this.code = 403
  }
}

export class TooManyRequestsError {
  constructor(retryAfter) {
    this.code = 429
    this.retryAfter = retryAfter
  }
}

// Optimistic-concurrency conflict (compare-and-set). The layout write's expectedVersion did not
// match the server's current version — the caller refetches, re-exports, and retries once.
export class ConflictError {
  constructor(error) {
    this.code = 409
    this.error = error
  }
}

export class PayloadTooLargeError {
  constructor(error) {
    this.code = 413
    this.error = error
  }
}
